import { FaUsers, FaMobileAlt, FaClipboardList, FaSearch, FaCalendarAlt, FaCreditCard, FaChartBar, FaRupeeSign, FaClock, FaGavel } from 'react-icons/fa';

function CreditControlSystemSection({ buyLink, onBuyClick }) {
  const features = [
    {
      icon: <FaUsers className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Team Training on payment collection ",
      subtitle: ""
    },
    {
      icon: <FaMobileAlt className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Advance followup system for faster payments",
      subtitle: ""
    },
    {
      icon: <FaClipboardList className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Credit Policy",
      subtitle: "e- credit policy client kyc system "
    },
    {
      icon: <FaSearch className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Client background and cibil check process",
      subtitle: "Credit Verification & Score"
    },
 
    {
      icon: <FaCreditCard className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Credit Limits",
      subtitle: "Per Client Cap"
    },
    {
      icon: <FaChartBar className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Working on Advance Payments",
      subtitle: ""
    },
    {
      icon: <FaRupeeSign className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "The C3 Formula",
      subtitle: "Credit terms | Credit limits | Credit days"
    },
    {
      icon: <FaClock className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "Payment Recovery Meetings",
      subtitle: "Execution Process"
    },
    {
      icon: <FaGavel className="text-4xl sm:text-5xl lg:text-6xl text-amber-400" />,
      title: "11 Unbeatable Laws of Payment Recovery",
      subtitle: ""
    }
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8 bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* Features Grid */}}}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8 lg:gap-10 max-w-[1200px] mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-7 sm:p-9 lg:p-11 text-center border border-amber-500/20 hover:border-amber-500/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.4),0_8px_10px_-6px_rgba(0,0,0,0.4)]"
            >
              {/* Icon */}
              <div className="w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 mx-auto mb-5 sm:mb-7 rounded-2xl bg-amber-500/15 flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform duration-300">
                {feature.icon}
              </div>

              {/* Title */}
              <div className="text-lg sm:text-xl lg:text-2xl text-white font-extrabold mb-2 leading-tight">
                {feature.title}
              </div>
              
              {/* Subtitle */}
              {feature.subtitle && (
                <div className="text-base sm:text-lg text-slate-400 font-medium">
                  {feature.subtitle}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CreditControlSystemSection;
